import React from "react";

/* ─── AQI Color bands ─── */
export const aqiMeta = (aqi) => {
  if (aqi <= 50)  return { color: "#22c55e", bg: "#dcfce7", label: "Good",                      text: "#166534" };
  if (aqi <= 100) return { color: "#eab308", bg: "#fef9c3", label: "Moderate",                   text: "#713f12" };
  if (aqi <= 150) return { color: "#f97316", bg: "#ffedd5", label: "Unhealthy for Sensitive",    text: "#7c2d12" };
  if (aqi <= 200) return { color: "#ef4444", bg: "#fee2e2", label: "Unhealthy",                  text: "#7f1d1d" };
  if (aqi <= 300) return { color: "#a855f7", bg: "#f3e8ff", label: "Very Unhealthy",             text: "#581c87" };
  return                  { color: "#7f1d1d", bg: "#fef2f2", label: "Hazardous",                 text: "#450a0a" };
};

export const severityColor = (s) => {
  if (s === "Critical") return { color: "#ef4444", bg: "#fee2e2" };
  if (s === "Warning")  return { color: "#f59e0b", bg: "#fef3c7" };
  return                       { color: "#3b82f6", bg: "#dbeafe" };
};

export const co2Color = (ppm) => {
  if (ppm < 800)  return "#22c55e";
  if (ppm < 1000) return "#eab308";
  if (ppm < 1200) return "#f97316";
  return "#ef4444";
};

export const pm25Color = (v) => {
  if (v < 30)  return "#22c55e";
  if (v < 60)  return "#eab308";
  if (v < 90)  return "#f97316";
  return "#ef4444";
};

export const tvocColor = (v) => {
  if (v < 0.3)  return "#22c55e";
  if (v < 0.5)  return "#eab308";
  if (v < 0.8)  return "#f97316";
  return "#ef4444";
};

export const windDirArrow = (deg) => {
  // Returns SVG transform for arrow pointing in wind direction
  return `rotate(${deg}, 50, 50)`;
};

/* ─── Shared Components ─── */

export const AqiGauge = ({ aqi, size = 100 }) => {
  const m = aqiMeta(aqi);
  const r = (size - 16) / 2;
  const circ = 2 * Math.PI * r;
  const fill = Math.min(1, aqi / 300) * circ;
  return (
    <svg width={size} height={size} style={{ flexShrink: 0 }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#f3f4f6" strokeWidth={12} />
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={m.color} strokeWidth={12}
        strokeDasharray={`${fill} ${circ - fill}`} strokeLinecap="round"
        transform={`rotate(-90 ${size/2} ${size/2})`} />
      <text x="50%" y="46%" textAnchor="middle" dy="0.35em" fontSize={size * 0.22} fontWeight="800" fill={m.color}>{aqi}</text>
      <text x="50%" y="70%" textAnchor="middle" fontSize={size * 0.1} fill="#9ca3af">AQI</text>
    </svg>
  );
};

export const AqiBadge = ({ aqi }) => {
  const m = aqiMeta(aqi);
  return (
    <span className="aqm-badge" style={{ background: m.bg, color: m.text, borderColor: m.color + "44" }}>
      {m.label}
    </span>
  );
};

export const KpiCard = ({ label, value, unit, color, icon: Icon, sub, alert }) => (
  <div className="aqm-kpi-card" style={{ borderTopColor: color }}>
    <div className="aqm-kpi-top">
      {Icon && <div className="aqm-kpi-icon" style={{ background: color + "18" }}><Icon size={18} color={color} /></div>}
      <div>
        <div className="aqm-kpi-value" style={{ color }}>{value}<span className="aqm-kpi-unit"> {unit}</span></div>
        <div className="aqm-kpi-label">{label}</div>
      </div>
    </div>
    {sub   && <div className="aqm-kpi-sub">{sub}</div>}
    {alert && <div className="aqm-kpi-alert">{alert}</div>}
  </div>
);

export const MiniBar = ({ value, max, color, height = 6 }) => (
  <div style={{ background: "#f3f4f6", borderRadius: 4, height, overflow: "hidden", width: "100%", minWidth: 60 }}>
    <div style={{ width: `${Math.min(100, (value / max) * 100)}%`, background: color, height: "100%", borderRadius: 4 }} />
  </div>
);

export const SeverityBadge = ({ severity }) => {
  const sc = severityColor(severity);
  return <span className="aqm-badge" style={{ background: sc.bg, color: sc.color }}>{severity}</span>;
};

export const WindArrow = ({ deg, size = 40 }) => {
  const rad = ((deg - 90) * Math.PI) / 180;
  const cx = size / 2, cy = size / 2, len = size * 0.38;
  const x2 = cx + Math.cos(rad) * len;
  const y2 = cy + Math.sin(rad) * len;
  return (
    <svg width={size} height={size}>
      <circle cx={cx} cy={cy} r={size / 2 - 2} fill="#f0f9ff" stroke="#bae6fd" strokeWidth={1.5} />
      <line x1={cx} y1={cy} x2={x2} y2={y2} stroke="#0369a1" strokeWidth={2} strokeLinecap="round" />
      <circle cx={x2} cy={y2} r={3} fill="#0369a1" />
      <text x={cx} y={cy + 1} textAnchor="middle" dominantBaseline="middle" fontSize={size * 0.16} fill="#6b7280" fontWeight="600">
        {["N","NE","E","SE","S","SW","W","NW"][ Math.round(deg / 45) % 8 ]}
      </text>
    </svg>
  );
};
